export const LAWS_WAITING_APPLY_SEARCH_FILTER = 'LAWS_WAITING_APPLY_SEARCH_FILTER';
export const LAWS_WAITING_REMOVE_SEARCH_ITEM = 'LAWS_WAITING_REMOVE_SEARCH_ITEM';
export const LAWS_WAITING_REMOVE_SEARCH_FILTER = 'LAWS_WAITING_REMOVE_SEARCH_FILTER';
export const LAWS_WAITING_CHANGE_IS_TITLE_ONLY = 'LAWS_WAITING_CHANGE_IS_TITLE_ONLY';

export const LAWS_WAITING_APPLY_CATEGORIES_FILTER = 'LAWS_WAITING_APPLY_CATEGORIES_FILTER';
export const LAWS_WAITING_REMOVE_CATEGORIES_FILTER = 'LAWS_WAITING_REMOVE_CATEGORIES_FILTER';
export const LAWS_WAITING_REMOVE_CATEGORY_FROM_FILTER = 'LAWS_WAITING_REMOVE_CATEGORY_FROM_FILTER';

export const LAWS_WAITING_APPLY_DATES_RANGE_FILTER = 'LAWS_WAITING_APPLY_DATES_RANGE_FILTER';
export const LAWS_WAITING_REMOVE_DATES_RANGE_FILTER = 'LAWS_WAITING_REMOVE_DATES_RANGE_FILTER';

export const LAWS_WAITING_APPLY_THEMES_FILTER = 'LAWS_WAITING_APPLY_THEMES_FILTER';
export const LAWS_WAITING_REMOVE_THEMES_FILTER = 'LAWS_WAITING_REMOVE_THEMES_FILTER';
export const LAWS_WAITING_REMOVE_THEME_FROM_FILTER = 'LAWS_WAITING_REMOVE_THEME_FROM_FILTER';

export const LAWS_WAITING_APPLY_DOCUMENT_TYPE_FILTER = 'LAWS_WAITING_APPLY_DOCUMENT_TYPE_FILTER';
export const LAWS_WAITING_REMOVE_DOCUMENT_TYPE_FILTER = 'LAWS_WAITING_REMOVE_DOCUMENT_TYPE_FILTER';
export const LAWS_WAITING_REMOVE_DOCUMENT_TYPE_FROM_FILTER = 'LAWS_WAITING_REMOVE_DOCUMENT_TYPE_FROM_FILTER';

// NEW FILTERS:

export const LAWS_WAITING_APPLY_PROJECTS_FILTER = 'LAWS_WAITING_APPLY_PROJECTS_FILTER';
export const LAWS_WAITING_REMOVE_PROJECTS_FILTER = 'LAWS_WAITING_REMOVE_PROJECTS_FILTER';
export const LAWS_WAITING_REMOVE_PROJECT_FROM_FILTER = 'LAWS_WAITING_REMOVE_PROJECT_FROM_FILTER';

export const LAWS_WAITING_APPLY_NPAS_FILTER = 'LAWS_WAITING_APPLY_NPAS_FILTER';
export const LAWS_WAITING_REMOVE_NPAS_FILTER = 'LAWS_WAITING_REMOVE_NPAS_FILTER';
export const LAWS_WAITING_REMOVE_NPA_FROM_FILTER = 'LAWS_WAITING_REMOVE_NPA_FROM_FILTER';

export const LAWS_WAITING_APPLY_DEADLINES_LOST_FILTER = 'LAWS_WAITING_APPLY_DEADLINES_LOST_FILTER';
export const LAWS_WAITING_REMOVE_DEADLINES_LOST_FILTER = 'LAWS_WAITING_REMOVE_DEADLINES_LOST_FILTER';
export const LAWS_WAITING_REMOVE_DEADLINE_LOST_FROM_FILTER = 'LAWS_WAITING_REMOVE_DEADLINE_LOST_FROM_FILTER';

export const LAWS_WAITING_APPLY_DEADLINES_FILTER = 'LAWS_WAITING_APPLY_DEADLINES_FILTER';
export const LAWS_WAITING_REMOVE_DEADLINES_FILTER = 'LAWS_WAITING_REMOVE_DEADLINES_FILTER';
export const LAWS_WAITING_REMOVE_DEADLINE_FROM_FILTER = 'LAWS_WAITING_REMOVE_DEADLINE_FROM_FILTER';

// NEW FILTERS END

export const LAWS_WAITING_APPLY_SOURCES_FILTER = 'LAWS_WAITING_APPLY_SOURCES_FILTER';
export const LAWS_WAITING_REMOVE_SOURCES_FILTER = 'LAWS_WAITING_REMOVE_SOURCES_FILTER';
export const LAWS_WAITING_REMOVE_SOURCE_FROM_FILTER = 'LAWS_WAITING_REMOVE_SOURCE_FROM_FILTER';

export const LAWS_WAITING_APPLY_GROUPS_FILTER = 'LAWS_WAITING_APPLY_GROUPS_FILTER';
export const LAWS_WAITING_REMOVE_GROUPS_FILTER = 'LAWS_WAITING_REMOVE_GROUPS_FILTER';
export const LAWS_WAITING_REMOVE_GROUP_FROM_FILTER = 'LAWS_WAITING_REMOVE_GROUP_FROM_FILTER';

export const LAWS_WAITING_CHANGE_IMPORTANCE_FILTER = 'LAWS_WAITING_CHANGE_IMPORTANCE_FILTER';

export const LAWS_WAITING_CHANGE_PLAN_FILTER = 'LAWS_WAITING_CHANGE_PLAN_FILTER';

export const LAWS_WAITING_CHANGE_SORT_FILTER = 'LAWS_WAITING_CHANGE_SORT_FILTER';

export const LAWS_WAITING_REMOVE_ALL_FILTERS = 'LAWS_WAITING_REMOVE_ALL_FILTERS';

export const LAWS_WAITING_SET_INITIAL_FILTERS = 'LAWS_WAITING_SET_INITIAL_FILTERS';
export const LAWS_WAITING_SET_FILTERS = 'LAWS_WAITING_SET_FILTERS';

export const APPLY_COVID_FILTERS = 'APPLY_COVID_FILTERS';



// WEBPACK FOOTER //
// ./src/redux_related/lawsWaitingFilters/actions.js